import supabase from '../supabaseClient';

/** True when sign-out failed only because there was no active session. */
export function isBenignAuthSignOutError(error) {
  if (!error) return false;
  const name = String(error.name || '');
  const msg = String(error.message || '').toLowerCase();
  return (
    name === 'AuthSessionMissingError'
    || msg.includes('session missing')
    || msg.includes('auth session missing')
  );
}

/**
 * Sign out in this browser only (clears local tokens).
 * Avoids POST /auth/v1/logout?scope=global which can 403 when the
 * refresh token is missing or already revoked.
 */
export async function signOutClientSession() {
  const { error } = await supabase.auth.signOut({ scope: 'local' });
  if (error && !isBenignAuthSignOutError(error)) {
    throw error;
  }
}
